import { useMutation, useQueryClient } from "react-query";
import { useContext, useState } from "react";
import { ToastContext } from "../../../../../../../../../hooks/context";
import { useParams, useSearchParams } from "react-router-dom";
import { updateStorefrontPolicies } from "../../../../../../../../../services/inventory";
import { cleanObject } from "../../../../../../../../../helpers";

export const usePolicies = ({ menuProperties }) => {
  const queryClient = useQueryClient();
  const { menuId } = useParams();
  const triggerToast = useContext(ToastContext);
  const [searchParams] = useSearchParams();
  const menu_id = searchParams.get("menu_id");
  const [policies, setPolicies] = useState(menuProperties?.policies || "");

  const [isEditing, setIsEditing] = useState(false);

  const {
    isLoading: isLoadingStorefrontPolicies,
    mutate: mutateStorefrontPolicies,
  } = useMutation({
    mutationFn: (data) => updateStorefrontPolicies(data),
    onSuccess: () => {
      triggerToast("Storefront policies updated successfully", "success");
      queryClient.invalidateQueries(["getMenusDetails"]);
      setIsEditing((prev) => !prev);
    },
  });

  const submitStorefrontPolicies = () => {
    mutateStorefrontPolicies(
      cleanObject({
        policies: policies,
        storefront_id: menu_id || menuId,
      }),
    );
  };

  return {
    policies,
    setPolicies,
    isEditing,
    isLoadingStorefrontPolicies,
    setIsEditing,
    submitStorefrontPolicies,
  };
};
